import React from "react";

const RewardsReferral = () => {
  return <div>RewardsReferral</div>;
};

export default RewardsReferral;